const MVCObject = require("./../mvcobject").MVCObject;
const maps = require("../maps");

/**
 * Constructs a new PlacesSearchSource
 *
 * AutocompleteRequest can be biased using location, radius or bounds property through the options param
 * @constructor
 * @param {google.maps.places.AutocompletionRequest} [options] The Google Places AutocompletionRequest
 * @param {Number} [minQuerySize] if the size of the input is smaller than minQuerySize then no request to googleMap is done (default 0)
 * @param {null|Function} [searchCallback] Callback to execute after search if set
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.location
 */
class PlacesSearchSource extends MVCObject {
    constructor(options, minQuerySize, searchCallback = null) {
        super();

        /**
         * Observes his autocomplete_query to launch the autocomplete.
         * @type {String}
         * @see woosmap.utils.MVCObject#bindTo
         */
        this.autocomplete_query = null;

        /**
         * When Places returns a prediction list it sets this property.
         * This property is observable
         * @type {Array}
         * @see woosmap.utils.MVCObject#bindTo
         */
        this.predictions = null;

        /**
         * Observes this property to launch configure autocomplete.
         * should comply to google's specifications
         * See : [AutocompletionRequest](https://developers.google.com/maps/documentation/javascript/reference#AutocompletionRequest)
         * @see woosmap.utils.MVCObject#bindTo
         * @type {Object}
         */
        this.options = options || {};

        /**
         * Callback to execute after search if needed
         * @type {null|Function}
         */
        this.searchCallback = searchCallback;

        /**
         * If autocomplete query change but with a length smaller than minQuerySize then no request to google map is done.
         * @type {Number}
         */
        this.minQuerySize = minQuerySize;
        this._placesImpl = maps.places.getPlacesImplementation(this);
    }

    /**
     * Listens the changes of autocomplete_query.
     */
    autocomplete_query_changed() {
        const autocomplete_query = this.get("autocomplete_query");
        if (autocomplete_query && autocomplete_query.length >= (this.minQuerySize || 0)) {
            this.search(autocomplete_query);
        } else {
            this.set("predictions", null);
        }
    }

    search(autocomplete_query) {
        return this._placesImpl.search(autocomplete_query);
    }

    getDetails(reference, callback) {
        return this._placesImpl.getDetails(reference, callback);
    }
}

exports.PlacesSearchSource = PlacesSearchSource;
